/**
 * FilterAndDisplay  Functional Component
 * @Package - seo/brandPart
 * @Author - Cybage@UPWA-Team
 * @description: FilterAndDisplay related to brandPart SEO
 */
/**
 *  BrandPart SEO's FilterAndDisplay Component
 */
import React from 'react'
import SeoFilterAndDisplay from '../SeoFilterAndDisplay'
import config from '../../../../config/local-config'

export default function FilterAndDisplay({
  dynamicApiData,
  isComponentChanged,
  apiDetails: {
    sortOptions = config.sortOptions,
    props: { core },
  },
}) {
  return (
    <SeoFilterAndDisplay
      id="BrandPartFilterAndDisplay"
      dynamicApiData={dynamicApiData}
      isComponentChanged={isComponentChanged}
      sortOptions={sortOptions}
      coreConfig={core}
    />
  )
}
